import { getChildEntities } from 'app/infrastructure/store/query';
import {
  getCaseData,
  getEntityContext
} from 'app/infrastructure/ui/renderer/resolvers';
import * as casedatamodel from 'app/area/case/case-data-model';

export const previousEnvironmentalValues = (caseState, uiEngineProps) => {
  const caseData = getCaseData(caseState, uiEngineProps);
  const entityContext = getEntityContext(caseState, uiEngineProps);
  const {
    amount,
    unitOfMeasure,
    caseNo,
    periodStart,
    periodEnd,
    greenNo,
    substanceCategory,
    substance
   } = casedatamodel.columnName[casedatamodel.tableName.prevGreen];

  const prevRows = getChildEntities(caseData, entityContext.path, casedatamodel.tableName.prevGreen);

  const filteredPrevValueRows = prevRows.map(row => {
    const {id, primaryKey} = row;
    return {
      id,
      primaryKey,
      amount: row[amount][0]?.value,
      unitOfMeasure: row[unitOfMeasure][0]?.description,
      caseNo: row[caseNo][0]?.value,
      periodStart: row[periodStart][0]?.value,
      periodEnd: row[periodEnd][0]?.value,
      greenNo: row[greenNo][0]?.value,
      substanceCategory: row[substanceCategory][0]?.description,
      substance: row[substance][0]?.description
    };
});
  return {
    previousEnvironmentalValues: filteredPrevValueRows  
  };
};

export interface PreviousEnvironmentalValuesShape {  
  previousEnvironmentalValues: {
  amount: number;
  unitOfMeasure: string;
  caseNo: number;
  periodStart: string;
  periodEnd: string;
  greenNo: number;
  substanceCategory: string;
  substance: string;
  }[];
}
